import React, { useCallback, useEffect, useState } from 'react'
import { useUserData } from '../../user/useUserData'
import { useNavigate } from 'react-router-dom'
import moment from 'moment-timezone'

import './InfoPage.scss'
import { BackButton } from '../../components/BackButton'
import { restaurants } from '../../constants/restaurantsData'
import { tips, pickRandom } from '../../constants/tipsData'
import { SEO } from '../../components/SEO'

export const InfoPage: React.FC = () => {
  const {
    startDate,
    duration,
    daysRemaining,
    serviceDays,
    percentageCompleted,
    pokemon,
    accumulatedMoney,
    finalDate,
    favoriteRestaurantUrl,
  } = useUserData()
  const navigate = useNavigate()

  const openSettings = useCallback(() => {
    void navigate('/asetukset')
  }, [navigate])

  const [timeLeft, setTimeLeft] = useState<string>('')
  const [tip, setTip] = useState<string | null>(null)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = moment().tz('Europe/Helsinki')
      const end = moment(finalDate).tz('Europe/Helsinki')
      const duration = moment.duration(end.diff(now))

      const days = Math.floor(duration.asDays())
      const hours = duration.hours()
      const minutes = duration.minutes()
      const seconds = duration.seconds()

      setTimeLeft(`${days} päivää ${hours} tuntia ${minutes} minuuttia ${seconds} sekuntia`)
    }

    calculateTimeLeft()
    const timer = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(timer)
  }, [finalDate])

  useEffect(() => {
    setTip(pickRandom(tips))
  }, [])

  return (
    <div className="page">
      <SEO
        title="Käyttäjätiedot | Aamukasaaja"
        description="Aamukasaaja on varusmiehen paras tietopaketti - kaikki asepalveluksesta yhdellä sivulla."
        keywords="aamukasa, tj, laskuri, intti, asepalvelus"
        canonical="https://aamukasaaja.fi/info"
      />
      <div className="header">
        <BackButton to="/" />
        <h2 className="title">Käyttäjätiedot</h2>
        <button type="button" className="settingsButton" onClick={openSettings}>
          Asetukset
        </button>
      </div>
      <div className="infoContainer">
        <div className="infoGrid">
          <div className="infoBox">
            <strong>Palvelukseen astuminen:</strong> {moment(startDate).format('DD.MM.YYYY')}
          </div>
          <div className="infoBox">
            <strong>Kotiutuminen:</strong> {moment(finalDate).format('DD.MM.YYYY')}
          </div>
          <div className="infoBox">
            <strong>Palveluksen pituus:</strong> {duration} päivää
          </div>
          <div className="infoBox">
            <strong>Tänään jäljellä:</strong> {daysRemaining} päivää
          </div>
          <div className="infoBox">
            <strong>Armeijan harmaissa:</strong> {serviceDays} päivää
          </div>
          <div className="infoBox">
            <strong>Palveluksesta suoritettu:</strong> {percentageCompleted} %
          </div>
          <div className="infoBox">
            <strong>Pokémon:</strong> {pokemon}
          </div>
          <div className="infoBox">
            <strong>Päivärahaa saatu:</strong> {accumulatedMoney.toFixed(2)} €
          </div>
          <div className="infoBox favoriteBox">
            <strong>Suosikkiravintola:</strong>{' '}
            {(() => {
              const fav = restaurants.find((r) => r.url === favoriteRestaurantUrl)
              if (!fav) {
                return 'Ei valittu'
              }
              return (
                <a
                  className="favoriteLink"
                  href={fav.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {fav.name}
                </a>
              )
            })()}
          </div>
          {tip && <div className="infoBox">"{tip}"</div>}
        </div>
        <div className="finalDate">
          <strong>TJ0:</strong> {timeLeft}
        </div>
      </div>
    </div>
  )
}
